import trackers from './trackers/index';
import recorders from './recorders/index';

const notNull = (x) => { return !!x; };

export default () => {
  return next => (reducer, initialState) => {
    const store = next(reducer, initialState);

    return {
      ...store,
      dispatch(action) {
        store.dispatch(action);

        const events = trackers.map(trackerFn => trackerFn(store.getState(), action)).filter(notNull);

        if (events && events.length) {
          try {
            recorders.forEach(recorderFn => events.forEach(event => recorderFn(event)));
          } catch (e) {
            console.info('error trying to track', e);  // eslint-disable-line no-console
          }
        }

        return action;
      },
    };
  };
};
